// extracted by mini-css-extract-plugin
module.exports = {"lia-avatar":"UserAvatar_lia-avatar__HFfcv","lia-avatar-img":"UserAvatar_lia-avatar-img__CUPwZ"};